import React, { useCallback, useContext, useEffect, useState } from 'react';
import EnquiryContext from './Enquiry.context';
import useCallbackRef from 'hooks/useCallbackRef';
import { EnquirySliderRef } from 'router/subrouters/Dash/subrouters/Business/components/EnquirySlider/EnquirySlider.component';
import { useLocation, useNavigate } from 'react-router-dom';
import EnquirySlider from 'router/subrouters/Dash/subrouters/Business/components/EnquirySlider';
import { AUTH_ROUTE, OPEN_ENQUIRY_HASH } from 'data/global';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

const Enquiry: React.FC = (props) => {
  const { children } = props;

  const { currentUser, openVerificationModal } = useContext(CurrentUserContext);

  const [selectedListingId, setSelectedListingId] = useState<string>();

  const [enquirySlider, enquirySliderRef] = useCallbackRef<EnquirySliderRef>();

  const { pathname, hash, state } = useLocation();

  const navigate = useNavigate();

  const openSlider = useCallback(
    (listingId: string) => {
      setSelectedListingId(listingId);
      enquirySlider?.open();
    },
    [enquirySlider],
  );

  const closeSlider = useCallback(() => {
    setSelectedListingId(undefined);
    enquirySlider?.close();
  }, [enquirySlider]);

  const onEnquire = useCallback(
    (listingId: string) => {
      if (currentUser && !currentUser?.hasVerifiedEmail) {
        navigate(pathname, { replace: true });
        openVerificationModal(false, listingId);
        return;
      }

      openSlider(listingId);
    },
    [currentUser, openSlider, navigate, pathname, openVerificationModal],
  );

  useEffect(() => {
    if (
      enquirySlider &&
      hash === OPEN_ENQUIRY_HASH &&
      !pathname.includes(AUTH_ROUTE)
    ) {
      const stateListingId = (state as { id: string })?.id;

      if (stateListingId) {
        onEnquire(stateListingId);
      }
    }
  }, [enquirySlider, hash, pathname, state, onEnquire]);

  return (
    <EnquiryContext.Provider value={{ onEnquire, closeModal: closeSlider }}>
      <EnquirySlider listingId={selectedListingId} ref={enquirySliderRef} />
      {children}
    </EnquiryContext.Provider>
  );
};

export default Enquiry;
